import React from 'react';
import { Activity, MessageDisplay, P } from '@fashionnovateam/nova-ui-toolkit';
import { PurchaseOrderChatMessage, useChatContext } from '../../Chat';
import { ChatUserTooltipContent } from '../../Chat/ChatUserTooltip';

export function ChatBackMessage(props: {
  message: PurchaseOrderChatMessage;
  isLast: boolean;
}) {
  const { message, isLast } = props;
  const { identity } = useChatContext();

  const isVendor =
    message.author?.attributes.type === 'vp' &&
    ['VENDOR', 'VENDOR_STAFF'].includes(message.author.attributes.role);
  const isInfluencer =
    message.author?.attributes.type === 'vp' &&
    ['INFLUENCER'].includes(message.author.attributes.role);
  const isInternal =
    message.author?.attributes.type === 'internal' ||
    (message.author?.attributes.type === 'vp' &&
      !['VENDOR', 'VENDOR_STAFF', 'INFLUENCER'].includes(
        message.author.attributes.role,
      ));

  const badge =
    (isVendor && 'vendor') ||
    (isInfluencer && 'influencer') ||
    (isInternal && 'fn_internal') ||
    undefined;

  return (
    <Activity
      name={message.author?.friendlyName || ''}
      badgeType={badge}
      hideBar={isLast}
      tooltipContent={
        <ChatUserTooltipContent
          name=""
          chatUser={message.author}
          badgeType={badge}
        />
      }
      tooltipZIndex={100}
    >
      <Activity.Message
        name={message.author?.friendlyName || ''}
        date={message.dateCreated}
        isPersonal={identity === message.author?.identity}
        tooltipZIndex={100}
      >
        {message.attributes.type === 'tiptap' ? (
          <MessageDisplay
            content={message.body}
            mentionUser={{ userId: identity }}
          />
        ) : (
          <P>{message.body}</P>
        )}
        {message.media?.length && (
          <P>There is {message.media.length} files attached to this message.</P>
        )}
      </Activity.Message>
    </Activity>
  );
}
